"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XIM2KQSLcjs = require('../__chunks/XIM2KQSL.cjs');
require('../__chunks/7JL3CCPE.cjs');


var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-disclosure.tsx
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var children = /* @__PURE__ */ _jsxruntime.jsx.call(void 0, 
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    pointerEvents: "none",
    children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "polyline", { points: "4,6 8,10 12,6" })
  }
);
var useComboboxDisclosure = _PTOCUU2Dcjs.createHook.call(void 0, function useComboboxDisclosure2({ store, ...props }) {
  const context = _EV33XSIBcjs.useComboboxProviderContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "ComboboxDisclosure must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const onMouseDownProp = props.onMouseDown;
  const onMouseDown = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    onMouseDownProp == null ? void 0 : onMouseDownProp(event);
    event.preventDefault();
    store == null ? void 0 : store.move(null);
  });
  const onClickProp = props.onClick;
  const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    if (!store) return;
    const { baseElement: baseElement2 } = store.getState();
    store.setDisclosureElement(baseElement2);
  });
  const baseElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "baseElement");
  const open = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "open");
  _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
    if (!baseElement) return;
    store.setDisclosureElement(baseElement);
  }, [store, baseElement]);
  props = {
    children,
    tabIndex: -1,
    "aria-label": open ? "Hide popup" : "Show popup",
    "aria-expanded": open,
    ...props,
    onMouseDown,
    onClick
  };
  props = _XIM2KQSLcjs.useDialogDisclosure.call(void 0, { store, ...props });
  return props;
});
var ComboboxDisclosure = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxDisclosure2(props) {
  const htmlProps = useComboboxDisclosure(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ComboboxDisclosure = ComboboxDisclosure; exports.useComboboxDisclosure = useComboboxDisclosure;
